import { render, staticRenderFns } from "./BoothStaffCard.vue?vue&type=template&id=6ea6c8b6&"
import script from "./BoothStaffCard.vue?vue&type=script&lang=js&"
export * from "./BoothStaffCard.vue?vue&type=script&lang=js&"
import style0 from "./BoothStaffCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports